import StatGroup from './StatGroup';

export type { StatGroupProps } from './StatGroup';
export default StatGroup;
